module.exports = __webpack_public_path__ + "static_pc/img/22.b93bc381.png";